import { ProductVideo } from 'components/ProductVideo';
import { ProductScreenshot } from 'components/ProductScreenshot';
import assignAnOverrideLight from "../../../../contents/images/features/experiments/assigning-an-override-light-mode.mp4";
import assignAnOverrideDark from "../../../../contents/images/features/experiments/assigning-an-override-dark-mode.mp4";
import resultLight from "../../../../contents/images/features/experiments/experiment-result-light-mode.png";
import resultDark from "../../../../contents/images/features/experiments/experiment-result-light-mode.png";
import * as React from 'react';
export default {
  ProductVideo,
  ProductScreenshot,
  assignAnOverrideLight,
  assignAnOverrideDark,
  resultLight,
  resultDark,
  React
};